// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F3VSa","content":"styles_content__vbY0v","tableWrap":"styles_tableWrap__2WEBn"};